import React from 'react';
import { useCredential } from '../../../hooks';
import { Link } from 'react-router-dom';
import { credentialImageURL } from '../../../hooks/helpers';
import './SingleCredentialDetailedView.css';

const SingleCredentialDetailedView = ({ credentialID }) => {
  const [credentialData, credentialDataLoaded] = useCredential(credentialID);
  return (
    <div className="panels">
      <div className="panels_cont">
        <div className="cred_user_div" style={{ display: 'none' }}>
          <img
            alt=""
            className="image-7"
            loading="lazy"
            src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
          />
          <div className="div-block-3">
            <div>
              This credential was issued to{' '}
              <a className="blue_link" href="public-profile.html">
                Ashley Miller
              </a>{' '}
              on 24 March 2022.
            </div>
          </div>
          <div className="div-block-120 mg_l">
            <div className="div-block-113 share_btn">
              <img
                alt=""
                className="image-55"
                loading="lazy"
                src="images/share_2share.png"
              />
              <div className="text-block-81">Share</div>
            </div>
          </div>
        </div>
        <div className="div-block-152">
          {credentialDataLoaded && (
            <>
              <div className="div-block-154">
                <img
                  alt=""
                  className="image-74"
                  loading="lazy"
                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 230px, 272px"
                  src={credentialImageURL(credentialData)}
                  onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    e.currentTarget.src = '/images/default_badge.png';
                  }}
                />

                {credentialData.credentialDetails?.metadata?.type && (
                  <div>
                    <div className="text-block-97">
                      <span className="text-span-4">Type:</span>
                      {credentialData.credentialDetails.metadata.type}
                    </div>
                    <div className="cr_line"></div>
                  </div>
                )}

                {credentialData.credentialDetails?.metadata?.level && (
                  <div>
                    <div className="text-block-97">
                      <span className="text-span-4">Level:</span>{' '}
                      {credentialData.credentialDetails.metadata.level}
                    </div>
                    <div className="cr_line"></div>
                  </div>
                )}

                {credentialData.credentialDetails?.metadata?.price && (
                  <div>
                    <div className="text-block-97">
                      <span className="text-span-4">Time:</span>
                      {credentialData.credentialDetails.metadata.price}
                    </div>
                    <div className="cr_line"></div>
                  </div>
                )}

                {credentialData.credentialDetails?.metadata?.time && (
                  <div>
                    <div className="text-block-97">
                      <span className="text-span-4">Cost:</span>{' '}
                      {credentialData.credentialDetails.metadata.time}
                    </div>
                  </div>
                )}
              </div>
              <div className="div-block-153">
                <div className="text-block-98 cr_name">
                  {credentialData.recipient.username}
                </div>
                <div className="div-block-156">
                  <div className="text-block-99">
                    Issued by{' '}
                    {credentialData.credentialDetails.issuerDetails.name}
                  </div>
                  <div className="text-block-100">
                    A completion credential
                    {credentialData?.course?.name && <> for {credentialData.course.name}</>} was
                    issued to {credentialData.recipient.username} on{' '}
                    {new Date(credentialData.issuedOn).toLocaleString('default', {
                      month: 'long',
                    })}{' '}
                    {new Date(credentialData.issuedOn).getDate()},{' '}
                    {new Date(credentialData.issuedOn).getFullYear()}.
                  </div>

                </div>

                <div className="div-block-156">
                  {credentialData.credentialDetails.metadata && (
                    <>
                      <div className="text-block-99">Skills</div>
                      <div className="div-block-155">
                        {credentialData.credentialDetails.metadata.skills.map(
                          (skill, i) => (
                            <div key={i} className="div-block-16 cr_skill">
                              <div className="text-block-12">{skill}</div>
                            </div>
                          )
                        )}
                      </div>
                    </>
                  )}
                </div>

                {/*TODO : add earning criteria scenario*/}
                {credentialData?.course?.name && (
                  <div className="div-block-156">
                    <div className="text-block-99">Course</div>
                    <Link
                      className="link-block-8 w-inline-block"
                      to={`/courses/${credentialData.course.course_id}`}
                    >
                      <img
                        alt=""
                        className="image-75"
                        loading="lazy"
                        src="images/document_1document.png"
                      />
                      <div className="text-block-101">
                        {credentialData.course.name}
                      </div>
                    </Link>
                  </div>
                )}

                <div className="div-block-156">
                  <div className="text-block-99">Issued on</div>
                  <div className="text-block-101 issue-date">
                    {new Date(credentialData.issuedOn).toLocaleString(
                      'default',
                      {
                        month: 'long',
                      }
                    )}{' '}
                    {new Date(credentialData.issuedOn).getDate()} ,{' '}
                    {new Date(credentialData.issuedOn).getFullYear()}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export { SingleCredentialDetailedView };
